import { createContext } from 'react';
import { DropdownProps, PanelOption, DropdownActions } from './Dropdown';

export enum DropdownTypes {
  SET_DISABLE_PARENT = 'parentDisabled',
  SET_DONE = 'done',
  SET_FILTER_FOCUSED = 'isFilterFocused',
  SET_FOCUSED_INDEX = 'focusedIndex',
  SET_KEY_PRESSED = 'pressedKey',
  SET_OPEN = 'open',
  SET_SELECTION = 'selection',
  SET_TOOLTIP_OPEN = 'tooltipOpen',
  SET_WAS_OPENED = 'wasOpened',
}

export interface DropdownAction {
  payload: boolean | number | string | PanelOption[];
  type: string;
}

export interface State {
  done: boolean;
  /** Index of the option which should receive focus. Expects undefined or int */
  focusedIndex?: number;
  isFilterFocused: boolean;
  open: boolean;
  parentDisabled: boolean;
  pressedKey?: string;
  /** Object representing the state of the current selection */
  selection: PanelOption[];
  tooltipOpen: boolean;
  wasOpened: boolean;
}

export const initialState: State = {
  focusedIndex: undefined,
  isFilterFocused: true,
  parentDisabled: false,
  done: false,
  open: false,
  pressedKey: '',
  selection: [],
  tooltipOpen: false,
  wasOpened: false,
};

export function dropdownReducer(state = initialState, { payload, type }: DropdownAction) {
  switch (type) {
    case DropdownTypes.SET_OPEN:
      return { ...state, open: payload as boolean };
    case DropdownTypes.SET_DONE:
      return { ...state, done: payload as boolean };
    case DropdownTypes.SET_KEY_PRESSED:
      return { ...state, pressedKey: payload as string };
    case DropdownTypes.SET_DISABLE_PARENT:
      return { ...state, parentDisabled: payload as boolean };
    case DropdownTypes.SET_FILTER_FOCUSED:
      return { ...state, isFilterFocused: payload as boolean };
    case DropdownTypes.SET_FOCUSED_INDEX:
      return { ...state, focusedIndex: payload as number };
    case DropdownTypes.SET_SELECTION:
      return { ...state, selection: payload as PanelOption[] };
    case DropdownTypes.SET_TOOLTIP_OPEN:
      return { ...state, tooltipOpen: payload as boolean };
    case DropdownTypes.SET_WAS_OPENED:
      return { ...state, wasOpened: payload as boolean };
    default:
      return state;
  }
}

export interface IDropdownContext {
  ariaLabel?: string;
  divRef?: React.RefObject<HTMLDivElement>;
  dropdownActions?: Partial<DropdownActions>;
  props?: DropdownProps;
  state: State;
  uniqueId?: string;
}

const DropdownContext = createContext<IDropdownContext>({
  state: { ...initialState },
});

export default DropdownContext;
